function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12,0H4C2.9,0,2,0.9,2,2l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V6L12,0z M16,18H4V2h7.2L16,6.8V18z M6.4,8.6 L5.3,7.4V11h3.6L7.4,9.6C8,8.5,9,7.8,10.2,7.8c1.7,0,3.2,1.4,3.2,3.2s-1.4,3.1-3.2,3.1c-1.1,0-2-0.5-2.6-1.3H6.1 c0.7,1.6,2.3,2.7,4.1,2.7c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5C8.6,6.5,7.2,7.3,6.4,8.6L6.4,8.6z"
});

var SvgReassigned = function SvgReassigned(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReassigned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reassigned.b81e7592.svg";
export { ForwardRef as ReactComponent };